/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UserViewingReportInfo
 */
export interface UserViewingReportInfo {
    /**
     * 
     * @type {string}
     * @memberof UserViewingReportInfo
     */
    'typeCode': UserViewingReportInfoTypeCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserViewingReportInfo
     */
    'point': string;
    /**
     * 
     * @type {number}
     * @memberof UserViewingReportInfo
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof UserViewingReportInfo
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof UserViewingReportInfo
     */
    'endDate': string;
}

export const UserViewingReportInfoTypeCodeEnum = {
    AutoInstagramFollow: 'auto-instagram-follow-',
    AutoInstagramLike: 'auto-instagram-like-',
    ClickFacebookComment: 'click-facebook-comment-',
    ClickFacebookFollow: 'click-facebook-follow-',
    ClickFacebookLike: 'click-facebook-like-',
    ClickFacebookPagelike: 'click-facebook-pagelike-',
    ClickInstagramComment: 'click-instagram-comment-',
    ClickInstagramFollow: 'click-instagram-follow-',
    ClickInstagramLike: 'click-instagram-like-',
    ClickThreadsComment: 'click-threads-comment-',
    ClickThreadsFollow: 'click-threads-follow-',
    ClickThreadsLike: 'click-threads-like-',
    ClickYoutubeComment: 'click-youtube-comment-',
    ClickYoutubeLike: 'click-youtube-like-',
    ClickYoutubeSubscribe: 'click-youtube-subscribe-',
    PlusInstagramLike: 'plus-instagram-like-',
    PlusInstagramPost: 'plus-instagram-post-',
    ClickNblogLike: 'click-nblog-like-',
    ClickNblogFollow: 'click-nblog-follow-',
    ClickNblogComment: 'click-nblog-comment-',
    ClickNblogScrap: 'click-nblog-scrap-',
    ClickNplaceBookmark: 'click-nplace-bookmark-',
    ClickNplaceNotification: 'click-nplace-notification-',
    MacroClickInstagramLike: 'macro_click-instagram-like-',
    MacroClickInstagramFollow: 'macro_click-instagram-follow-',
    MacroClickInstagramComment: 'macro_click-instagram-comment-',
    MacroClickThreadsLike: 'macro_click-threads-like-',
    MacroClickThreadsFollow: 'macro_click-threads-follow-',
    MacroClickThreadsComment: 'macro_click-threads-comment-',
    MacroClickFacebookLike: 'macro_click-facebook-like-',
    MacroClickFacebookFollow: 'macro_click-facebook-follow-',
    MacroClickFacebookComment: 'macro_click-facebook-comment-',
    MacroClickFacebookPagelike: 'macro_click-facebook-pagelike-',
    MacroClickYoutubeSubscribe: 'macro_click-youtube-subscribe-',
    MacroClickYoutubeLike: 'macro_click-youtube-like-',
    MacroClickYoutubeComment: 'macro_click-youtube-comment-',
    PostNblogBlog: 'post-nblog-blog-',
    MacroClickNblogLike: 'macro_click-nblog-like-',
    MacroClickNblogFollow: 'macro_click-nblog-follow-',
    MacroClickNblogComment: 'macro_click-nblog-comment-',
    MacroClickNblogScrap: 'macro_click-nblog-scrap-',
    MacroClickNplaceBookmark: 'macro_click-nplace-bookmark-',
    MacroClickNplaceNotification: 'macro_click-nplace-notification-'
} as const;

export type UserViewingReportInfoTypeCodeEnum = typeof UserViewingReportInfoTypeCodeEnum[keyof typeof UserViewingReportInfoTypeCodeEnum];


